export default "__VITE_ASSET__BxrYlVc3__"